import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Navbar from "../components/navbar";

import './header.css';

const Header = ({ siteTitle, currentPage }) => (
  <header
    style={{
      // background: `#D6E6FF`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.45rem 1.0875rem 1.0875rem`,
        textAlign: `center`,
        // display: `flex`,
        // flexWrap: `wrap`,
        // alignItems: `center`,
        // justifyContent: `center`,
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: `#444545`,
            textDecoration: `none`,
          }}
        >
          {siteTitle}
        </Link>
      </h1>
      <Navbar currentPage={currentPage} />
      {/* <hr className={"gradient"}/> */}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
